import { TermsOfService } from "../components/TermsOfService";

export function TermsOfServicePage() {
  return (
    <main id="main-content" tabIndex={-1}>
      <TermsOfService mode="page" />
    </main>
  );
}
